import type { EShelfMaterial } from '../../../core/EShelfMaterial';
import { DrawCabinetInsideElement } from './DrawCabinetInsideElement';

export class DrawInsideShelf extends DrawCabinetInsideElement {
    Material!: EShelfMaterial;
    IsFixed!: boolean;
}
